// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-tab-color-default: var(--ds-color-grey-20);
    --ds-tab-color-active: var(--ds-color-grey-10);
    --ds-tab-color-hover: var(--ds-color-grey-10);
    --ds-tab-color-focus: var(--ds-color-grey-10);
    --ds-tab-focus-outline-color: var(--ds-color-focus-outline);
    --ds-tab-ghost-active-border-color: var(--ds-color-indigo-3);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
